import { Component, OnInit, inject } from '@angular/core';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {selectUserPermissions} from '../store/selectors';
import {filter, first, tap} from 'rxjs/operators';
import {TenantService} from '../services/tenant.service';

/**
 *
 * This component install the instructor chat on the app, that allows the instructor to ask questions to the app helpdesk.
 *
 * This chat system is only available to instructors or to app admin users in general.
 *
 * The instructors can install their separate chat systems to talk to students, using the Third-Party Scripts option
 * of the Admin Settings / Integrations tab.
 *
 */


@Component({
    selector: "instructor-chat",
    template: "",
    standalone: true
})
export class InstructorChatComponent implements OnInit {
  private store = inject<Store<AppState>>(Store);
  private tenant = inject(TenantService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }

  ngOnInit() {

    this.store.pipe(
      select(selectUserPermissions),
      filter(roles => roles.isAdmin),
      first(),
      tap(() => this.activateInstructorChat())

    )
    .subscribe();

  }

  private activateInstructorChat() {

    const tenant = this.tenant.tenant;

    const isEmbed = window.location.pathname?.includes('course-embed');

    if (isEmbed) {
      console.log(`Skipping customer chat activation for embeds.`);
      return;
    }

    // these code snippets comes from the Help Scout Dashboard
    // API Docs https://developer.helpscout.com/beacon-2/web/javascript-api/
    this.ensureHelpScoutBeacon();

    const Beacon = window["Beacon"];

    // disable chat support if on the free plan
    if (tenant.instructorPricingPlan == 'growth') {
      Beacon('config', {
        messaging: {
          chatEnabled: false
        },
        labels: {
          responseTime: 'During your 30-day trial you have email support. Upgrade for chat support.'
        },
      });
    }

  }

  private ensureHelpScoutBeacon() {
    const win = window as any;
    if (!win.Beacon) {
      const beacon = function (method: string, options?: any, data?: any) {
        (beacon as any).readyQueue.push({ method, options, data });
      } as any;
      (beacon as any).readyQueue = [];
      win.Beacon = beacon;
    }

    if (!document.querySelector('script[data-helpscout-beacon]')) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://beacon-v2.helpscout.net';
      script.setAttribute('data-helpscout-beacon', 'true');

      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
  }
}
